import React, { ButtonHTMLAttributes, FC } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

const styles = {
  blue: 'bg-blue-700 text-white rounded hover:bg-blue-800 border border-blue-700',
  danger:
    'bg-red-200 text-red-700 rounded hover:bg-red-300 border border-red-700',
  blueOutline:
    'bg-white text-blue-700 border border-blue-700 rounded hover:bg-blue-50 dark:bg-gray-900',
  activeOutline:
    'bg-white text-green-400 border border-green-400 rounded cursor-not-allowed',
  locked:
    'bg-white text-gray-700 border border-gray-700 rounded cursor-not-allowed opacity-50',
};

const sizes = {
  small: 'text-sm px-2 py-1',
  medium: 'text-base px-4 py-2',
  large: 'text-lg px-6 py-4',
};

const loadingStroke: Partial<Record<keyof typeof styles, string>> = {
  blue: '#FFFFFF',
  danger: '#C10007',
  blueOutline: '#1D4ED8',
  activeOutline: '#22C55E',
  locked: '#6B7280',
};

interface DefaultButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style' | 'onClick'> {
  children: React.ReactNode;
  style: keyof typeof styles;
  size?: keyof typeof sizes;
  onclick?: () => void; // 👈 behouden voor backward compatibility
  loading?: boolean;
}

const DefaultButton: FC<DefaultButtonProps> = ({
  children,
  onclick,
  style,
  size = 'medium',
  className = '',
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <button
      className={`
        ${styles[style]}
        ${sizes[size]}
        ${className}
        inline-flex items-center justify-center gap-2
        transition-colors
      `}
      onClick={onclick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <LoadingSpinner stroke={loadingStroke[style]} />}

      <span>{children}</span>
    </button>
  );
};

export default DefaultButton;
